import { useEffect, useState } from "react";
import { fetchItemGroup3s, downloadItemGroup3Excel } from "../Api/ViewItemGroup3";
import { Container, Table, Button } from "react-bootstrap";

import { toast } from "react-toastify";
import moment from "moment";

const ViewItemGroup3 = () => {
  const [itemGroups, setItemGroups] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const loadItemGroups = async () => {
      try {
        const data = await fetchItemGroup3s();
        setItemGroups(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Item Group 3 Data`);
      }
    };

    loadItemGroups();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadItemGroup3Excel();
      
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'ItemGroup3_Data.xlsx');
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);
      
      toast.success("Item Group 3 data download started!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="list-container">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h2 className="list-title">View Item Group 3</h2>
              <Button className="generate-btn"
                variant="primary" 
                onClick={handleDownload}
                disabled={isDownloading || itemGroups.length === 0}
              >
                {isDownloading ? 'Downloading...' : 'Download Data'}
              </Button>
            </div>

            {itemGroups.length > 0 ? (
              <Table bordered hover responsive className="data-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Code</th>
                    <th>Description</th>
                    <th>Item Group Code</th>
                    <th>Item Group 1</th>
                    <th>Item Group 2</th>
                    <th>Created On</th>
                    <th>Created By</th>
                    <th>Changed On</th>
                    <th>Changed By</th>
                  </tr>
                </thead>
                <tbody>
                  {itemGroups.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.code}</td>
                      <td>{item.description}</td>
                      <td>{item.itemGroupCode}</td>
                      <td>{item.itemGroup1}</td>
                      <td>{item.itemGroup2}</td>
                      <td>
                        {moment(item.createdOnDate).format('L')} at {item.createdOnTime?.substring(0, 8)}
                      </td>
                      <td>{item.createdBy}</td>
                      <td>
                        {item.changedOnDate ? 
                          `${moment(item.changedOnDate).format('L')} at ${item.changedOnTime?.substring(0, 8)}` 
                          : 'N/A'}
                      </td>
                      <td>{item.changedBy || 'N/A'}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p className="no-data">No item group 3 data found.</p>
            )}
          </Container>
        </div>
      
    </>
  );
};

export default ViewItemGroup3;